import script from "./StatoProgrammi.vue?vue&type=script&setup=true&lang=js"
export * from "./StatoProgrammi.vue?vue&type=script&setup=true&lang=js"

import "./StatoProgrammi.vue?vue&type=style&index=0&id=667f7d2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667f7d2f"]])

export default __exports__